import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import apiClient from '../api/api-client'
import { AxiosResponse } from 'axios'

import { DashboardData, DashboardDataCollection, type KennzahlStudiengang } from '../model'
import { useLoading } from '@/js/utils/useLoading'

export const useDashboardDataStore = defineStore('dashboardData', () => {
    const { isLoading, setLoading, errors, hasError } = useLoading()
    const dashboardData = ref<Array<DashboardData>>([])

    const getDashboardData = computed(() =>
        dashboardData.value.sort((a, b) => Number(a.hsaId ?? 0) - Number(b.hsaId ?? 0))
    )

    const getDashboardDataByKennzahlStudiengangId = computed(() => {
        return (kennzahlStudiengangId: string) => {
            return dashboardData.value.filter(
                (entry) => entry.kennzahlStudiengangId === kennzahlStudiengangId
            )
        }
    })
    const getDashboardDataByStudiengangIri = computed(() => {
        return (dashboardDataIri: string) => {
            return dashboardData.value.find((dashboardData) => {
                return dashboardData['@id'] === dashboardDataIri
            })
        }
    })

    async function fetchDashboardData(): Promise<void> {
        await setLoading('fetching dashboardData', async () => {
            dashboardData.value = []
            const url = '/api/dashboard-data'
            const response: AxiosResponse<DashboardDataCollection, any> = await apiClient.get(url, {
                params: {
                    pagination: false
                }
            })
            dashboardData.value = response.data['hydra:member']
        })
    }

    async function fetchDashboardDataByKennzahlStudiengangId(
        kennzahlStudiengangId: KennzahlStudiengang['kennzahlStudiengangId']
    ): Promise<void> {
        await setLoading('fetching dashboardData', async () => {
            dashboardData.value = []
            const url = `/api/dashboard-data`
            const response: AxiosResponse<DashboardDataCollection, any> = await apiClient.get(url, {
                params: {
                    pagination: false,
                    kennzahlStudiengangId
                }
            })
            dashboardData.value = response.data['hydra:member']
        })
    }

    return {
        dashboardData,
        isLoading,
        errors,
        hasError,
        fetchDashboardData,
        fetchDashboardDataByKennzahlStudiengangId,
        getDashboardData,
        getDashboardDataByKennzahlStudiengangId,
        getDashboardDataByStudiengangIri
    }
})
